import {
    LADDER_TYPE_CONFIG,
    LADDER_HEIGHT_CONFIG,
    LADDER_MODEL_CONFIG,
    LADDER_PATTERNS
} from './config';

export const extractStepsCount = (name) => {
    if (!name || typeof name !== 'string') return null;
    const normalizedName = name.toLowerCase();

    for (const pattern of LADDER_PATTERNS) {
        const match = normalizedName.match(pattern);
        if (match) {
            const steps = parseInt(match[1], 10);
            if (steps >= 2 && steps <= 5) return steps;
        }
    }
    return null;
};

export const determineLadderGroup = (name) => {
    if (!name || typeof name !== 'string') return null;
    const normalizedName = name.toLowerCase();

    for (const keyword of LADDER_TYPE_CONFIG.GROUP_1.keywords) {
        if (normalizedName.includes(keyword)) return 'GROUP_1';
    }
    for (const keyword of LADDER_TYPE_CONFIG.GROUP_2.keywords) {
        if (normalizedName.includes(keyword)) return 'GROUP_2';
    }
    return null;
};

export const selectLadderModel = (name, poolType = 'скиммерный') => {
    if (!name || typeof name !== 'string') return '/models/ladders/ladder10.glb';

    const stepsCount = extractStepsCount(name);

    if (stepsCount === 2) {
        const normalizedPoolType = (poolType || '').toLowerCase();
        if (normalizedPoolType === 'переливной') return '/models/ladders/ladder12.glb';
        return '/models/ladders/ladder2.glb';
    }

    let group = determineLadderGroup(name);
    if (!group && stepsCount) group = 'GROUP_1';
    if (!group) return '/models/ladders/ladder10.glb';
    if (!stepsCount) return '/models/ladders/ladder10.glb';

    const groupConfig = LADDER_TYPE_CONFIG[group];
    const modelName = groupConfig?.models?.[stepsCount];

    if (modelName) return `/models/ladders/${modelName}`;
    return '/models/ladders/ladder10.glb';
};

export const getLadderHeightConfig = (modelName) => {
    if (!modelName || typeof modelName !== 'string') return 0.0;
    const fileName = modelName.split('/').pop();
    return LADDER_HEIGHT_CONFIG[fileName]?.baseHeight || 0.0;
};

export const getLadderDepthCoefficient = (modelName) => {
    if (!modelName || typeof modelName !== 'string') return 1.0;
    const fileName = modelName.split('/').pop();
    return Math.abs(LADDER_HEIGHT_CONFIG[fileName]?.depthCoefficient ?? 1.0);
};


export const getLadderScale = (modelPath) => {
    let baseScale = LADDER_MODEL_CONFIG.SCALE;
    if (modelPath) {
        const fileName = modelPath.split('/').pop();
        if (LADDER_MODEL_CONFIG.INDIVIDUAL_SCALES[fileName]) {
            baseScale = LADDER_MODEL_CONFIG.INDIVIDUAL_SCALES[fileName];
        }
    }
    // Масштаб фиксированный, не зависит от размера бассейна
    return [...baseScale];
};

export const getLadderRotation = (cornerIndex) => {
    let rotation = Math.PI / 2;

    if (cornerIndex === 1 || cornerIndex === 2) {
        rotation += Math.PI;
    }
    return [0, rotation, 0];
};
